/* eslint-disable import/prefer-default-export */
export const CANNOT_MODIFY_CART = 'CANNOT_MODIFY_CART';